import * as React from 'react'
import { I18nService } from '../../services/utils/i18n.service'

interface Props {
  termsOfSaleUrl: string | null
  checked: boolean
  onChange: (checked: boolean) => void
  hasError?: boolean
}

const i18nScoped = new I18nService(require('./terms-of-use-checkbox.component.yml'))

export default function TermsOfUseCheckboxComponent ({ termsOfSaleUrl, checked, onChange, hasError }: Props) {
  return <div className={ `inputCheckbox ${hasError ? 'has-errors' : ''}` }>
    <input id="accept_term_of_use" type="checkbox" checked={ checked } onChange={ event => onChange(event.target.checked) } />
    <label htmlFor="accept_term_of_use">
      <span>
        { i18nScoped.tFragment('i_agree_terms_of_sale_html', {
          // opening the terms of sale in a new tab breaks e2e tests that click the checkbox's label
          url: window.env === 'test' ? i18nScoped.t('terms_of_sale') : <a href={ termsOfSaleUrl } target="_blank" rel="noopener noreferrer">{ i18nScoped.t('terms_of_sale') }</a>
        }) }
      </span>
    </label>
  </div>
}